import React from 'react'
import { useSelector } from 'react-redux'
import { useRoute } from '@react-navigation/native'
import { StyleService, useStyleSheet } from '@src/style/service'
import { ChartTypes } from '@src/components/Timeline/constants'
import { NavigationContainer } from '@src/screens/Common/containers'
import { AppRouteProp } from '@src/navigation/types'
import { eventsForDateSelector } from '@src/selectors/events'
import { eventsChartsSelector } from '@src/models/dailyCharts/selectors'
import { ChartModal as ChartModalComponent } from '../components/ChartModal'
import { EventsItemType } from '../models/events.types'

export const ChartModalContainer = () => {
  const charts = useSelector(eventsChartsSelector<EventsItemType>(eventsForDateSelector))
  const route = useRoute<AppRouteProp<'ZoomChart'>>()
  const styles = useStyleSheet(themedStyle)

  const { type = ChartTypes.Glucose } = route.params

  return (
    <NavigationContainer style={styles.container} showLoadingIndicator>
      <ChartModalComponent charts={charts} type={type} />
    </NavigationContainer>
  )
}

const themedStyle = StyleService.create({
  container: {
    backgroundColor: 'theme.background.modal',
  },
  chart: {
    flex: 1,
  },
})
